import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6); /* Semi-transparent black overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it's on top of other content */
`;

export const ModalContent = styled.div`
  background-color: white; /* White background for the modal */
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  width: 90%; /* Responsive width */
  max-width: 600px; /* Maximum width for larger screens */
  text-align: center;
  box-sizing: border-box; /* Include padding in width */

  @media (min-width: 768px) {
    padding: 40px;
  }
`;

export const Title = styled.h2`
text-align: center;
margin-top: 30px;
font-weight: 600;
font-size: 20px;
line-height: 24px;
letter-spacing: 0.03em;
color: ${colors.black};
`;

export const Message = styled.p`
margin-top: 20px;
  max-width: 521px;
  font-size: 14px;
  line-height: 23px;
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
  text-align: center;
`;

export const Question = styled.p`
text-align: center;
margin-top: 30px;
font-weight: 600;
font-size: 18px;
line-height: 24px;
letter-spacing: 0.03em;
color: ${colors.black};
`;

export const StyledTextArea = styled.textarea`
  width: calc(100% - 20px); /* Full width minus padding */
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid ${(props) => (props.$hasError ? 'red' : '#ccc')}; /* Red border on error */
  border-radius: 5px;
  font-size: 0.9rem;
  min-height: 80px; /* Minimum height for textarea */
  resize: vertical; /* Allow vertical resizing */
  box-sizing: border-box; /* Include padding and border in width */

  &:focus {
    outline: none;
    border-color: #007bff; /* Example focus color */
  }

  @media (min-width: 768px) {
    min-height: 100px;
    font-size: 1rem;
  }
`;

export const ErrorMessage = styled.p`
  color: red;
  font-size: 0.85rem;
  margin-top: -10px;
  margin-bottom: 15px;
`;

export const SubmitButton = styled.button`
width:100%;
max-width: 292px;
margin: auto;
height: 32px;
letter-spacing: 0.03em;
font-weight: bold;
font-size: 14px;
line-height: 17px;
border-radius: 48px;
transition: .2s;

&#top-action-button {
  background: ${colors.bgPrimary};
  color: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border: 1px solid ${colors.bgPrimaryLight};

  &:hover {
    background: ${colors.bgPrimaryHover};
    border: 1px solid ${colors.bgPrimaryLight};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    -webkit-box-shadow: 0px 5px 10px ${colors.shadowHover};
    -moz-box-shadow: 0px 5px 10px ${colors.shadowHover};
  }
}

&#bottom-action-button {
  margin-top: 20px;
  background: ${colors.white};
  border: 1px solid #9CA1AE;
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  color: ${colors.textPrimary};

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    -webkit-box-shadow: 0px 5px 10px ${colors.shadowHover};
    -moz-box-shadow: 0px 5px 10px ${colors.shadowHover};
  }
}
`;